import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const fieldContainerStyle = css({
  padding: theme.spacing(2),
  backgroundColor: theme.colors.neutral5,
  border: `1px dashed ${theme.colors.neutral20}`,
  borderRadius: theme.borderRadius.medium,
});

export const emptyStateStyle = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
});

export const uploadTextStyle = css({
  marginTop: theme.spacing(1),
  marginBottom: 0,
});

export const descTextStyle = css({
  marginTop: theme.spacing(0.5),
  marginBottom: 0,
});

export const fieldsetStyle = css({
  border: 'none',
  margin: 0,
  padding: 0,
  minWidth: 0,
});

export const fieldLabelStyle = css({
  marginBottom: theme.spacing(0.5),
});

export const addImageButtonStyle = css({
  width: 'auto',
  marginTop: theme.spacing(1),
});

export const imageCollectionStyle = css({
  display: 'grid',
  gridTemplateColumns: 'repeat(4, 1fr)',
  gap: theme.spacing(2),
});

export const imageCollectionItemStyle = css({
  aspectRatio: '80 / 92',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
  borderRadius: theme.borderRadius.small,
  position: 'relative',

  '> img': {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
});

export const uploadStatusOverlayStyle = css({
  position: 'absolute',
  inset: 0,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: `${theme.colors.neutral90}80`,
  gap: theme.spacing(0.5),
});

export const uploadStatusOverlayErrorStyle = css({
  position: 'absolute',
  inset: 0,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: `${theme.colors.neutral90}30`,
  gap: theme.spacing(0.5),
});

export const removeIconButtonStyle = css({
  top: theme.spacing(0.5),
  right: theme.spacing(0.5),
  position: 'absolute',
  backgroundColor: theme.colors.white,
});

export const addMoreButtonStyle = css({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
});

export const fieldErrorStyle = css({
  color: theme.colors.text.critical,
  marginTop: theme.spacing(1),
});

export const overlayInlineTextStyle = css({
  margin: 0,
  color: theme.colors.white,
  fontWeight: theme.font.weight.bold,
  textAlign: 'center',
});

export const overlayErrorIconStyle = css({
  color: theme.colors.status.warning,
  flexShrink: 0,
});

export const retryButtonStyle = css({
  fontSize: theme.font.size.small,
  color: theme.colors.white,
  textDecoration: 'underline',
  fontWeight: theme.font.weight.bold,
});
